const ClientWalletRolesMap = [
    {
        id: '1',
        displayName: 'View Only',
        label: 'V',
    },
    {
        id: '2',
        displayName: 'Maker',
        label: 'M',
    },
    {
        id: '3',
        displayName: 'Approver',
        label: 'A',
    },
    {
        id: '4',
        displayName: 'Full Access',
        label: 'F',
    },
];

export enum ClientWalletRoleEnum {
    NOT_ASSIGNED = '0',
    VIEW_ONLY = '1',
    MAKER = '2',
    APPROVER = '3',
    FULL_ACCESS = '4',
}

export default ClientWalletRolesMap;
